export default "__VITE_ASSET__OoX90HzW__"